import React from "react";
import { Button, HStack, Menu, Portal } from "@chakra-ui/react";
import { RiArrowDownSFill } from "react-icons/ri";
import { Link } from "react-router";

function Component({ selected, data }: { selected: string; data: any }) {
  return (
    <div className="NavBar">
      <HStack backgroundColor="lightblue" height={"60px"}>
        {data.webPortalTitle}
        <Button asChild variant="ghost" {...getBGColour("stocks")}>
          <Link to="/stocks">Stocks</Link>
        </Button>
        <TeamsMenu buttonProps={getBGColour("teams")} teams={data.teams} />
        <Button asChild variant="ghost" {...getBGColour("league")}>
          <Link to="/">League Table</Link>
        </Button>
      </HStack>
    </div>
  );

  function getBGColour(selection: string) {
    return selection === selected ? { backgroundColor: "blue.100" } : {};
  }
}

function TeamsMenu({
  buttonProps,
  teams,
}: {
  buttonProps: object;
  teams: any;
}) {
  return (
    <Menu.Root>
      <Menu.Trigger asChild {...buttonProps}>
        <Button variant="ghost">
          Teams <RiArrowDownSFill />
        </Button>
      </Menu.Trigger>
      <Portal>
        <Menu.Positioner>
          <Menu.Content>
            {teams.map((team: any) => (
              <Menu.Item key={team.TeamId} value={team.TeamId} asChild>
                <Link to={"/team/" + team.TeamId}>{team.Name}</Link>
              </Menu.Item>
            ))}
          </Menu.Content>
        </Menu.Positioner>
      </Portal>
    </Menu.Root>
  );
}
export default Component;
